import React from 'react';

import classes from './Spinner.module.scss';

const spinner = (props) => {
        let children = [...Array(10).keys()].map(i => <div key={i} className={[classes['sk-circle'+(i+1)], classes['sk-child']].join(' ')}></div>)
        return (
            <div className={[classes['sk-circle'], classes[props.type]].join(' ')}>
            {children}
            </div>
        );
    }    

export default spinner;